import { Linking } from 'react-native';
import { AppRecord } from '../types';

const MARKET_URL_BASE = 'https://play.google.com/store/apps/details?id=';

export default async function openAppInGooglePlay(
  app: AppRecord
): Promise<void> {
  await openPackageInGooglePlayStore(app.package_name);
}

export async function openPackageInGooglePlayStore(
  package_name?: string
): Promise<void> {
  await Linking.openURL(MARKET_URL_BASE + package_name);
}
